import { type TypographyVariantProps, compoundMapper } from "@povio/ui";
import { type VariantProps, cva } from "class-variance-authority";

export const checkbox = cva(["flex items-center justify-center border-2", "relative size-4 shrink-0 rounded-xs p-1"], {
  variants: {
    variant: {
      default: [
        "m-1 border-interactive-contained-secondary-idle",
        "text-interactive-contained-primary-on-idle",
        "group-disabled:bg-interactive-contained-secondary-disabled",
        "group-hover:bg-interactive-contained-secondary-hover",
        "group-pressed:bg-interactive-contained-secondary-pressed",
        "group-selected:bg-interactive-contained-primary-idle",
        "group-selected:border-interactive-contained-primary-idle",
        "group-selected:group-hover:bg-interactive-contained-primary-hover",
        "group-selected:group-pressed:bg-interactive-contained-primary-pressed",
        "group-focus-visible:outline-interactive-text-secondary-focus",
        "before:bg-interactive-contained-secondary-on-idle",
        "group-hover:before:bg-interactive-contained-secondary-on-hover",
        "group-disabled:before:bg-interactive-contained-secondary-on-disabled",
        "group-selected:before:bg-interactive-contained-primary-on-idle",
        "group-selected:group-hover:before:bg-interactive-contained-primary-on-hover",
        "group-selected:group-pressed:before:bg-interactive-contained-primary-on-pressed",
      ],
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

export interface CheckboxVariantProps extends VariantProps<typeof checkbox> {}

export const checkboxTypography = compoundMapper<TypographyVariantProps, CheckboxVariantProps>({
  default: {
    size: "label-1",
  },
});
